const DATE_FORMAT = {
  defaultDate: 'yyyy-MM-dd',
  noYearDate: 'MM-dd',
  defaultDateWithTime: 'yyyy-MM-dd HH:mm',
};

export default DATE_FORMAT;
